<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M6 0.5C5.44772 0.5 5 0.947715 5 1.5V5.5H1C0.447715 5.5 0 5.94771 0 6.5C0 7.05228 0.447715 7.5 1 7.5H5V11.5C5 12.0523 5.44772 12.5 6 12.5C6.55228 12.5 7 12.0523 7 11.5V7.5H11C11.5523 7.5 12 7.05228 12 6.5C12 5.94771 11.5523 5.5 11 5.5H7V1.5C7 0.947715 6.55228 0.5 6 0.5Z"
  />
</template>
